/**
 * 机器状态
 */
export const MATHINE_STATUS_PENDING = 1;
export const MATHINE_STATUS_RUNNING = 2;
export const MATHINE_STATUS_ERROR = 3;
export const MATHINE_STATUS_CLOSED = 0
export const MATHINE_STATUS_LABEL = {
	[MATHINE_STATUS_PENDING]: '空闲中',
	[MATHINE_STATUS_RUNNING]: '运行中',
	[MATHINE_STATUS_ERROR]: '异常',
	[MATHINE_STATUS_CLOSED]: '已关闭',
};
export const MATHINE_STATUS_COLOR = {
	[MATHINE_STATUS_PENDING]: '#79A5F6',
	[MATHINE_STATUS_RUNNING]: '#52C41A',
	[MATHINE_STATUS_ERROR]: '#FAAD14',
	[MATHINE_STATUS_CLOSED]: '#FF4D4F',
};

/**
 * 日志状态
 */
export const LOGS_STATUS_PENDING = 1;
export const LOGS_STATUS_RUNNING = 2;
export const LOGS_STATUS_FINISH = 3;
export const LOGS_STATUS_ERROR = 4;
export const LOGS_STATUS_STOP = 5;
export const LOGS_STATUS_STOPPING = 6;
export const LOGS_STATUS_PAUSED = 7;
export const LOGS_STATUS_LABEL = {
	[LOGS_STATUS_PENDING]: '待执行',
	[LOGS_STATUS_RUNNING]: '执行中',
	[LOGS_STATUS_FINISH]: '完成',
	[LOGS_STATUS_ERROR]: '异常',
	[LOGS_STATUS_STOP]: '已停止',
	[LOGS_STATUS_STOPPING]: '停止中',
	[LOGS_STATUS_PAUSED]: '已暂停'
};
export const LOGS_STATUS_COLOR = {
	[LOGS_STATUS_PENDING]: '#79A5F6',
	[LOGS_STATUS_RUNNING]: '#52C41A',
	[LOGS_STATUS_FINISH]: '#D4D7DF',
	[LOGS_STATUS_ERROR]: '#FAAD14',
	[LOGS_STATUS_STOP]: '#FF4D4F',
	[LOGS_STATUS_STOPPING]: '#FF4D4F',
	[LOGS_STATUS_PAUSED]: '#e6a23c',
};

/**
 * 子任务状态
 */
export const SUB_LOGS_STATUS_TO_BE_EXECUTED = 0;
export const SUB_LOGS_STATUS_SUCCESS = 1;
export const SUB_LOGS_STATUS_FAIL = 2;
export const SUB_LOGS_STATUS_RUNNING = 3;
export const SUB_LOGS_STATUS_NO_EXECUTION_REQUIRED = 4;
export const SUB_LOGS_STATUS_LABEL = {
	[SUB_LOGS_STATUS_TO_BE_EXECUTED]: '待执行',
	[SUB_LOGS_STATUS_SUCCESS]: '成功',
	[SUB_LOGS_STATUS_FAIL]: '失败',
	[SUB_LOGS_STATUS_RUNNING]: '运行中',
	[SUB_LOGS_STATUS_NO_EXECUTION_REQUIRED]: '无需执行',
}
export const SUB_LOGS_STATUS_COLOR = {
	[SUB_LOGS_STATUS_TO_BE_EXECUTED]: '#79A5F6',
	[SUB_LOGS_STATUS_SUCCESS]: '#52C41A',
	[SUB_LOGS_STATUS_FAIL]: '#FF4D4F',
	[SUB_LOGS_STATUS_RUNNING]: '#52C41A',
	[SUB_LOGS_STATUS_NO_EXECUTION_REQUIRED]: '#D4D7DF',
}

/**
 * 任务状态 @ 任务列表状态
 * 0 未开启 1 已开启 2 运行中 3 已成功 4 已结束 5 已关闭 6 异常 7 触发一次
 */
export const TASK_STATUS_STARTED = 1;
export const TASK_STATUS_RUNNING = 2;
export const TASK_STATUS_FINISHED = 4;
export const TASK_STATUS_CLOSED = 5;
export const TASK_STATUS_UNUSUAL = 6;
// export const TASK_STATUS_TO_START = 0;
// export const TASK_STATUS_SUCCESS = 3;
// export const TASK_STATUS_STARTONCE = 7;
export const TASK_STATUS_LABEL = {
	[TASK_STATUS_STARTED]: '已开启',
	[TASK_STATUS_RUNNING]: '运行中',
	[TASK_STATUS_FINISHED]: '已结束',
	[TASK_STATUS_CLOSED]: '已关闭',
	[TASK_STATUS_UNUSUAL]: '异常',
	// [TASK_STATUS_TO_START]: '未开启',
	// [TASK_STATUS_SUCCESS]: '已成功',
	// [TASK_STATUS_STARTONCE]: '触发一次',
}
export const TASK_STATUS_COLOR = {
	[TASK_STATUS_STARTED]: '#409EFF',
	[TASK_STATUS_RUNNING]: '#52C41A',
	[TASK_STATUS_FINISHED]: '#D4D7DF',
	[TASK_STATUS_CLOSED]: '#FF4D4F',
	[TASK_STATUS_UNUSUAL]: '#FAAD14',
	// [TASK_STATUS_TO_START]: '未开启',
	// [TASK_STATUS_SUCCESS]: '已成功',
	// [TASK_STATUS_STARTONCE]: '触发一次',
}

/**
 * 账号类型
 */
export const USE_MODE_COOMPANY = 0;
export const USE_MODE_PERSON = 1;
export const USE_MODE_LABEL = {
	[USE_MODE_COOMPANY]: '公司',
	[USE_MODE_PERSON]: '个人',
};

/**
 * appCode&Label 映射
 */
export const APP_CODE_CANCEL_BOOKING = 'cancel_booking';
export const APP_CODE_BC_PARSE = 'bc_parse';
export const APP_CODE_QUERY_PRICE_QQ = 'query_price_qq';
export const APP_CODE_QUERY_PRICE_QQ_QQS = 'query_price_qq_qqs';
export const APP_CODE_QUERY_TRACKER = 'query_tracker';
export const APP_CODE_QUERY_SCHEDULE = 'query_schedule';
export const APP_CODE_BOOKING = 'booking';
export const APP_CODE_EPTRADE_QUERY_SMA_EXCEL = 'eptrade_query_cma_excel';
export const APP_CODE_LABEL = {
	[APP_CODE_QUERY_PRICE_QQ]: {
    name: '查询运价(QQ)',
    desc: '一键安排，快速查询多个点到点港口组合QQ运价信息，轻松接收运价结果～',
    saveAction: '/22001/facade/commons/params/template/saveFreightRatesParams',
    getAction: '/22001/facade/commons/params/template/getFreightRatesParams',
  },
  [APP_CODE_QUERY_PRICE_QQ_QQS]: {
    name: '查询运价(QQ&QQS)',
    desc: '一键安排，快速查询多个点到点港口组合QQ&QQS运价信息，轻松接收运价结果～',
    saveAction: '/22001/facade/commons/params/template/saveFreightRatesParams',
    getAction: '/22001/facade/commons/params/template/getFreightRatesParams',
  },
  [APP_CODE_QUERY_TRACKER]: {
    name: '船舶动态时间查询',
    desc: '一键安排，快速查询多条船舶挂靠时间计划信息，轻松接收船期结果～',
    saveAction: '/22001/facade/commons/params/template/saveFreightRatesParams',
    getAction: '/22001/facade/commons/params/template/getFreightRatesParams',
  },
	[APP_CODE_QUERY_SCHEDULE]: {
		name: '查询船期',
		desc: '一键安排，快速查询多个点到点港口组合船期信息，轻松接收船期结果～',
		saveAction: '/22001/facade/commons/params/template/saveQueryScheduleParams',
		getAction: '/22001/facade/commons/params/template/getQueryScheduleParams',
	},
	[APP_CODE_BOOKING]: {
		name: '批量订舱',
		desc: '一键安排，即可快速有序地处理多个船期订舱任务，确保每一个订舱任务都能妥善安排～',
		saveAction: '/22001/facade/commons/params/template/saveBatchBookingParams',
		getAction: '/22001/facade/commons/params/template/getBatchBookingParams',
	},
	[APP_CODE_BC_PARSE]: {
		name: 'BC解析',
		desc: '自动汇总整理BC文件信息，随时提供给您最需要的准确且关键的信息～',
		saveAction: '/22001/facade/commons/params/template/saveBcParseParams',
		getAction: '/22001/facade/commons/params/template/getBcParseParams',
	},
	[APP_CODE_CANCEL_BOOKING]: {
		name: '取消订舱',
		desc: '一键安排，即可快速处理多个订舱号退载任务，准确省心又高效～',
		saveAction: '/22001/facade/commons/params/template/saveBatchShutoutParams',
		getAction: '/22001/facade/commons/params/template/getBatchShutoutParams',
	},
	[APP_CODE_EPTRADE_QUERY_SMA_EXCEL]: {
		name: '自动订舱及查询预配',
		desc: '自动订舱及查询预配，准确省心又高效～',
		saveAction: '/22001/facade/commons/params/template/saveAutoBookingParams',
		getAction: '/22001/facade/commons/params/template/getAutoBooking',
	}
}

/**
 * 箱型
 */
export const CONTAINER_TYPE_20GP = '20GP';
export const CONTAINER_TYPE_40GP = '40GP';
export const CONTAINER_TYPE_40HC = '40HC';
export const CONTAINER_TYPE_45HC = '45HC';
export const CONTAINER_TYPE_20NOR = '20NOR';
export const CONTAINER_TYPE_40NOR = '40NOR';
export const CONTAINER_TYPE_20RF = '20RF';
export const CONTAINER_TYPE_40RF = '40RF';
export const CONTAINER_TYPE_40OT = '40OT';
export const CONTAINER_TYPE_40HCOT = '40HCOT';
export const CONTAINER_TYPE_40HCHT = '40HCHT';
export const CONTAINER_TYPE_LABEL = {
	[CONTAINER_TYPE_20GP]: CONTAINER_TYPE_20GP,
	[CONTAINER_TYPE_40GP]: CONTAINER_TYPE_40GP,
	[CONTAINER_TYPE_40HC]: CONTAINER_TYPE_40HC,
	[CONTAINER_TYPE_45HC]: CONTAINER_TYPE_45HC,
	[CONTAINER_TYPE_20NOR]: CONTAINER_TYPE_20NOR,
	[CONTAINER_TYPE_40NOR]: CONTAINER_TYPE_40NOR,
	[CONTAINER_TYPE_20RF]: CONTAINER_TYPE_20RF,
	[CONTAINER_TYPE_40RF]: CONTAINER_TYPE_40RF,
	[CONTAINER_TYPE_40OT]: CONTAINER_TYPE_40OT,
	[CONTAINER_TYPE_40HCOT]: CONTAINER_TYPE_40HCOT,
	[CONTAINER_TYPE_40HCHT]: CONTAINER_TYPE_40HCHT
}

/**
 * 运价数据库状态
 */
export const FREIGHT_RATES_STATUS_VALID = 1;
export const FREIGHT_RATES_STATUS_INVALID = 2;
export const FREIGHT_RATES_STATUS_LABEL = {
	[FREIGHT_RATES_STATUS_VALID]: '有效',
	[FREIGHT_RATES_STATUS_INVALID]: '无效'
}